// extracted by mini-css-extract-plugin
export const container = "Footer-module--container--3Tg7M";
export const title = "Footer-module--title--eh0Dq";
export const footer = "Footer-module--footer--2GJgl";
export const nav = "Footer-module--nav--3h9Cp";
export const primary = "Footer-module--primary--22sit";
export const secondary = "Footer-module--secondary--1k7g6";
export const logos = "Footer-module--logos--oHm9P";